import { Alert } from 'antd';
import styled, { css } from 'styled-components';

const StyledAlert = styled(Alert)`
  text-align: center;
  margin-bottom: 15px;
  ${(props) =>
    props.type === 'error' &&
    css`
      background: ${props.theme.buttonRed};
      border-color: ${props.theme.buttonRed};
      .ant-alert-message {
        color: #fff;
      }
    `};
  ${(props) =>
    props.type === 'success' &&
    css`
      background: ${props.theme.buttonGreen};
      border-color: ${props.theme.buttonGreen};
      .ant-alert-message {
        color: #fff;
      }
    `};
  ${(props) =>
    props.type === 'warning' &&
    css`
      background: ${props.theme.basicsWarning};
      border-color: ${props.theme.basicsWarning};
      .ant-alert-message {
        color: #fff;
      }
    `};
`;

export const ErrorAlert = styled(Alert)`
  text-align: center;
`;

export default StyledAlert;
